import { render, staticRenderFns } from "./BGAnimation.vue?vue&type=template&id=01aa565a&scoped=true"
import script from "./BGAnimation.vue?vue&type=script&lang=js"
export * from "./BGAnimation.vue?vue&type=script&lang=js"
import style0 from "./BGAnimation.vue?vue&type=style&index=0&id=01aa565a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa565a",
  null
  
)

export default component.exports